import React, { useState } from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import CustomOption from "./CustomOptions"; // Import your custom option component

const LeadCompainsDropdown = ({
  noobcampaigns,
  onChange,
  currentCampaign,
  onDeleteCampaign,
  onStartCampaign,
  onStopCampaign,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showStartModal, setShowStartModal] = useState(false);
  const [showStopModal, setShowStopModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const handleCampaignChange = (selected) => {
    onChange(selected);
  };

  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    onDeleteCampaign(selectedId);
    setShowDeleteModal(false);
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setSelectedId(null);
  };

  const handleStartClick = (id) => {
    setSelectedId(id);
    setShowStartModal(true);
  };

  const confirmStart = () => {
    onStartCampaign(selectedId);
    setShowStartModal(false);
  };

  const cancelStart = () => {
    setShowStartModal(false);
    setSelectedId(null);
  };

  const handleStopClick = (id) => {
    setSelectedId(id);
    setShowStopModal(true);
  };

  const confirmStop = () => {
    onStopCampaign(selectedId);
    setShowStopModal(false);
  };

  const cancelStop = () => {
    setShowStopModal(false);
    setSelectedId(null);
  };

  const optionsWithDelete = noobcampaigns.map((campaign) => ({
    value: campaign.label,
    label: campaign.label,
    id: campaign.value, // Assuming 'Name' is the string you want to display
    status: campaign.status,
    onDelete: handleDeleteClick,
    onStart: handleStartClick,
    onStop: handleStopClick,
  }));

  return (
    <>
      <Select
        options={optionsWithDelete}
        onChange={handleCampaignChange}
        value={
          optionsWithDelete.find(
            (campaign) => campaign.value === currentCampaign
          ) || null
        }
        components={{ Option: CustomOption }}
        className="w-full"
      />

      {/* Confirmation Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 flex justify-center items-center  bg-opacity-5 z-50">
          <div className="bg-white p-6 rounded border shadow-lg">
            <p className="mb-4 text-xl">
              Are you sure you want to delete this item?
            </p>
            <p className="mb-4 text-red-500">
              Warning: All the campaign data will be deleted permanently.
            </p>
            <div className="flex justify-end gap-2">
              <button
                onClick={cancelDelete}
                className="bg-gray-300 px-4 py-2 rounded"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="bg-red-500 text-white px-4 py-2 rounded"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {showStartModal && (
        <div className="fixed inset-0 flex justify-center items-center  bg-opacity-5 z-50">
          <div className="bg-white p-6 rounded border shadow-lg">
            <p className="mb-4">
              Are you sure you want to start this campaign?
            </p>
            <div className="flex justify-end gap-2">
              <button
                onClick={cancelStart}
                className="bg-gray-300 px-4 py-2 rounded"
              >
                Cancel
              </button>
              <button
                onClick={confirmStart}
                className="bg-green-500 text-white px-4 py-2 rounded"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {showStopModal && (
        <div className="fixed inset-0 flex justify-center items-center  bg-opacity-5 z-50">
          <div className="bg-white p-6 rounded border shadow-lg">
            <p className="mb-4">Are you sure you want to stop this campaign?</p>
            <div className="flex justify-end gap-2">
              <button
                onClick={cancelStop}
                className="bg-gray-300 px-4 py-2 rounded"
              >
                Cancel
              </button>
              <button
                onClick={confirmStop}
                className="bg-green-500 text-white px-4 py-2 rounded"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

LeadCompainsDropdown.propTypes = {
  noobcampaigns: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  currentCampaign: PropTypes.string,
  onDeleteCampaign: PropTypes.func.isRequired, // Ensure the delete function is passed as a prop
  onStartCampaign: PropTypes.func.isRequired, // Ensure the start function is passed as a prop
  onStopCampaign: PropTypes.func.isRequired, // Ensure the stop function is passed as a prop
};

export default LeadCompainsDropdown;
